<template>
  <PageRender
    :id="value.id"
    :key="value.id"
    :sections="[value]"
    :global-style="this.defaultGlobalStyles"
  />
</template>

<script>
import { mapState } from "vuex";
import PageRender from "../page-lib/components/PageRender";

export default {
  name: "IframePageRender",
  components: {
    PageRender,
  },
  data() {
    return {
      value: {},
    };
  },
  computed: {
    ...mapState({
      defaultGlobalStyles: (state) => state.defaultGlobalStyles,
    }),
  },
  created() {
    if (window.addEventListener) {
      window.addEventListener("message", this.getData, false)
    } else {
      window.attachEvent("onmessage", this.getData)
    }
  },
  destroyed() {},
  methods: {
    getData(e) {
      let data = e.data
      if (data && data.template) {
        if (window.parent) {
            const event = new CustomEvent('received', { detail: data, })
            window.parent.document.dispatchEvent(event)
        }
        this.value = data
      }
    },
  },
};
</script>